'use client';

import { Item, Indicator } from '@radix-ui/react-radio-group';
import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef } from 'react';
import { Icon } from '@/shared/ui/icon';
import './amount-radio.scss';

const amountRadioVariant = cva('amount-radio', {
    variants: {
        size: {
            sm: 'amount-radio--sm',
            md: 'amount-radio--md',
        },
        checked: {
            true: 'amount-radio--checked',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});

type Props = VariantProps<typeof amountRadioVariant> & ComponentPropsWithRef<typeof Item>;
export const AmountRadio = ({ className, size = 'md', checked, ...props }: Props) => {
    return (
        <Item
            data-slot="amount-radio"
            className={amountRadioVariant({ size, checked, className })}
            {...props}
        >
            <Indicator forceMount data-slot="amount-radio-indicator" className="amount-radio__indicator">
                {checked ? (
                    <Icon name="check" width={24} height={24} />
                ) : (
                    <Icon name="plus" width={24} height={24} className="amount-radio__plus-icon" />
                )}
            </Indicator>
        </Item>
    );
};
